import React from 'react';
import { CUIAutoComplete, CUIAutoCompleteProps } from 'chakra-ui-autocomplete';
import { FormControl } from '@chakra-ui/react';

interface AutoCompleteProps extends CUIAutoCompleteProps<any> {
  error?: string | null;
  disableItems?: boolean;
  onClick?: () => void;
}

export const AutoComplete: React.VFC<AutoCompleteProps> = ({
  label,
  placeholder,
  items,
  selectedItems,
  onCreateItem,
  onSelectedItemsChange,
  error = null,
  disableItems,
  onClick,
  ...props
}) => {
  return (
    <FormControl onClick={onClick}>
      <CUIAutoComplete
        labelStyleProps={{ fontSize: '14px', margin: '0' }}
        label={label}
        tagStyleProps={{
          bg: 'gray.300',
          color: 'gray.800',
          fontWeight: '400',
          fontSize: '15px',
          maxHeight: '1.5rem',
          height: '100%',
          marginLeft: '8px',
          marginBottom: '5px !important',
        }}
        listStyleProps={{
          maxHeight: '200px',
          overflowY: 'scroll',
          fontSize: '15px',
        }}
        placeholder={placeholder}
        inputStyleProps={{
          bg: 'gray.100',
          borderColor: 'gray.300',
          _placeholder: {
            color: 'gray.500',
            fontSize: '15px',
          },
          ...(!!error && { borderColor: '#E53E3E', borderWidth: '2px' }),
        }}
        listItemStyleProps={{
          ...(disableItems
            ? { pointerEvents: 'none' }
            : { pointerEvents: 'auto' }),
        }}
        onCreateItem={onCreateItem}
        disableCreateItem
        items={items}
        hideToggleButton
        selectedItems={selectedItems}
        onSelectedItemsChange={onSelectedItemsChange}
        {...props}
      />
    </FormControl>
  );
};
